<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row mb-3x">
    <input (change)="isKomplementaerKgChanged()" class="form-check-input"
           formControlName="isKomplementaerKg"
           id="isKomplementaerKg"
           type="checkbox"/>
    <label class="form-check-label"
           for="isKomplementaerKg">{{ kgTitle | translate }}
    </label>
  </div>

  <div class="form-row mb-3x">
    <input class="form-check-input" formControlName="isGewerblichTaetig"
           id="isGewerblichTaetig"
           type="checkbox"/>
    <label class="form-check-label"
           for="isGewerblichTaetig">{{ taetigTitle | translate }}
    </label>
  </div>

  <div class="form-row">
    <label class="col-sm-4 col-form-label" for="bezeichnungKg">
      {{ 'COMMON_UI.FRAGEBOGEN.BEZEICHNUNG_KG_ANGABEN.BEZEICHNUNG_KG' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="bezeichnungKg{{objectId}}" formControlName="bezeichnungKg"
             id="bezeichnungKg"
             type="text"
             utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

</form>
